import { Link } from 'apps/shared/scripts/components';
import { SimpleCardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';

import CardItemBody from './CardItemBody';
import CardItemFooter from './CardItemFooter';
import CardItemHeader from './CardItemHeader';
import { cardItemClassName } from './styles';

type Props = SimpleCardFragment;

const CardItem = ({
  createdAt,
  headline,
  id,
  postCount,
  recipientName,
  status,
}: Props) => {
  return (
    <Link className={cardItemClassName} to={`/dashboard/cards/${id}?rd=1`}>
      <CardItemHeader recipientName={recipientName} />
      <CardItemBody headline={headline} />
      <CardItemFooter
        createdAt={createdAt}
        postCount={postCount}
        status={status}
      />
    </Link>
  );
};

CardItem.displayName = 'CardItem';

export default CardItem;
